// src/components/store/sections/blog-posts/BlogV96BentodigestRoyalViolet.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV96BentodigestRoyalViolet(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={96}
      archKey="bento_digest"
      archLabel="Bento Digest Tiles"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
